import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { Account } from '@/models/Account';
import { monolithApi } from '@/utils/api';

const useAccounts = (): UseQueryResult<Account[]> =>
  useQuery({
    queryKey: ['accounts'],

    queryFn: async () => {
      const { data: accountsResult } = await monolithApi.get<Account[]>('/me/accounts');
      return accountsResult;
    },
  });

export default useAccounts;
